import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import Vue from 'vue';

const getInitialState = () => ({
  reports: {},
  error: {},
  settings: {}
});

export default {
  namespaced: true,
  name: 'problemReport',
  getters: {
    sendingEnable: state => !!state.settings.sending_enabled,
    reports: state => state.reports,
  },
  state: getInitialState,
  mutations: {
    SET_REPORT(state, { taskId, report }) {
      Vue.set(state.reports, taskId, report);
    },
    REMOVE_REPORT(state, taskId) {
      Vue.delete(state.reports, taskId);
    },
    SET_ERRORS(state, error) {
      state.error = error;
    },
    SET_SETTINGS(state, value) {
      state.settings = value;
    }
  },
  actions: {
    GET_SETTINGS({ commit }) {
      return this.$api.get('/api/v2/settings/reports/')
        .then((response) => {
          commit('SET_SETTINGS', response.data.problem);
          return response;
        });
    },
    REPORT_PROBLEM({ commit }, body) {
      return this.$api.post('/api/v2/reports/', body)
        .catch((error) => {
          commit('SET_ERRORS', error);
          throw error;
        });
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
    socket_tasks({ dispatch, commit, rootGetters }, { name, task_id, result, state: taskState }) {
      if (name === TaskName.REPORT_PROBLEM && taskState === TaskState.SUCCESS) {
        const primaryNode = rootGetters['nodes/getPrimaryNode'];

        if (!result.id && !primaryNode) {
          this.$takeFirst('nodes/FETCH_ITEMS');
        }

        dispatch('GET_SETTINGS').then(() => {
          commit('SET_REPORT', {
            taskId: task_id,
            report: {
              path: result.path,
              reportId: result.id
            }
          });
        });
      }
    }
  }
};
